import Vue from 'vue'
import Vuex from 'vuex'
import DashboardModule from '@/store/modules/dashboard';
import OnboardModule from '@/store/modules/onboard';
import ProductsModule from '@/store/modules/products';
import CustomersModule from '@/store/modules/customers';
import OrdersModule from '@/store/modules/orders';
import PrintModule from '@/store/modules/print';
import BillsModule from '@/store/modules/bills';
import SalesAgentModule from '@/store/modules/salesAgent';
import PaymentSlipModule from '@/store/modules/paymentSlip';
import PreShipmentsModule from '@/store/modules/preShipments';
import UtilModule from '@/store/modules/util';

import ShippersModule from '@/store/modules/shippers';
import SettingsModule from '@/store/modules/settings';
import UserModule from '@/store/modules/user';
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({ storage: window.localStorage })

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    dashboard: DashboardModule,
    products: ProductsModule,
    customers: CustomersModule,
    orders: OrdersModule,
    bills: BillsModule,
    print: PrintModule,
    preShipments: PreShipmentsModule,
    onboard: OnboardModule,
    user: UserModule,
    salesAgent: SalesAgentModule,
    paymentSlip: PaymentSlipModule,
    util: UtilModule,

    settings: SettingsModule,
    shippers: ShippersModule
  },
  plugins: [vuexLocal.plugin]
})


